module.exports = __webpack_public_path__ + "static/churchs-59764c7ab3c695838816dc6c273a372d.png";